import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';
import Style from '../Styles/Common.module.css';
import constants from '../../services/constants';
const AbouMayoBanner = (props)=>{
  const imageData = props.SliderImage
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
          },
          tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
          },
          mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
          }
      };
     
    return(
        <section className={Style.aboutmayo}>
          <div className={Style.pageTitle + ' ' + Style.mayoajmer}>
           <Container >
                <Row>
                    <Col md={12}>
                        <div className={Style.sectionTitle}>
                            <h2>About MAAD (Mayo College Alumni Association Delhi)</h2>
                        </div>
                    </Col>
                    </Row>
                    </Container>
                    <Container fluid={true}>
                      <Row>
                        <Col lg={5} className={Style.padd0}>
                        <div className={Style.amjerlogo}>
                            <img alt="" src={require('../../assest/images/about-MAAD-logo.png')}/>
                           
                        </div>
                    </Col>
                      <Col lg={7} className={Style.padd0}>
                        <Carousel autoPlay={true} autoPlaySpeed={3000} infinite={true} responsive={responsive}showDots={true} pauseOnHover={false} removeArrowOnDeviceType={['desktop','tablet', 'mobile']}>
                          {imageData.map((item)=>{
                            return(
                              <div key={item._id}>
                                  <img effect='blur' src={constants.IMAGE_BASE_URL_WITHOUT_UPLOAD+'/'+item.image}/>
                              </div>
                            )
                          })}
                        </Carousel>
                    </Col>
                </Row>
            </Container>
          </div>
    
        </section>        
    )
}

export default AbouMayoBanner;